import React from 'react';

import { cn } from '@/lib/utils';

const HEX = /^#?([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

/** "#aabbcc" for a usable hex, else null. */
export function normaliseHex(hex?: string | null): string | null {
    if (!hex) return null;
    const m = hex.trim().match(HEX);
    return m ? `#${m[1]}` : null;
}

/**
 * A product's colour: a small round sample and its name. Without a usable hex
 * there is no sample — a grey dot would read as "grey".
 */
export const ColourSwatch: React.FC<{ hex?: string | null; name?: string | null; size?: 'sm' | 'md'; className?: string }> = ({ hex, name, size = 'sm', className }) => {
    const colour = normaliseHex(hex);
    if (!colour && !name) return <span className={cn('text-muted-foreground', className)}>—</span>;
    return (
        <span className={cn('inline-flex min-w-0 items-center gap-1.5', className)} title={colour ? `${name || ''} ${colour}`.trim() : undefined}>
            {colour && (
                <span
                    className={cn('shrink-0 rounded-full border border-foreground/15', size === 'md' ? 'size-4' : 'size-3')}
                    style={{ backgroundColor: colour }}
                    aria-hidden
                />
            )}
            {name && <span className="truncate">{name}</span>}
        </span>
    );
};
